<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/setting/category/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ساخت دسته بندی جدید</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="category.name" label="نام دسته بندی"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="category.label" label="لیبل دسته بندی"></v-text-field>
          </v-col>

          <v-col cols="3">
            <v-text-field label="کاور"
                          @click="openFileDialog()" prepend-icon="mdi-plus"
                          color="black"
                          v-model="category.icon"></v-text-field>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="نوع"
                      :items="[{text:'دوره',value:'course'},{text:'درس های دوره',value:'course_item'},{text:'فایل درسی',value:'item_file'}]"
                      color="black" v-model="category.type">
            </v-select>
          </v-col>

          <v-col cols="12">
            <ckeditor color="black" v-model="category.description"></ckeditor>
          </v-col>

          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="uploadFileDialog" max-width="50vw">
      <drag-and-drop module="category" ref="image-uploader" @closeUploadFileDialog="uploadFileDialog = false"
                     @changeFile="category.icon = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
  name: "CategoryCreateView",
  components: {DragAndDrop},
  data() {
    return {
      uploadFileDialog: false,
      category: {
        name: null,
        label: null,
        type: null,
        icon: null,
        description: null,
      }
    }
  },
  mounted() {
  },
  methods: {
    store() {
      window.axios.post('category/create', this.category).then(() => {
        this.openSnackbar("دسته بندی جدید با موفقیت ساخته شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.category = {
        name: null,
        label: null,
        type: null,
        icon: null,
        description: null,
      }
    },
    openFileDialog() {
      this.uploadFileDialog = true
    },
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>